import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import Markdown from "@irati/ui/src/Markdown"

import {Container} from "./styled"

const CircledConnector = ({data, className, comp}) => {
  return (
    <Container className={classNames("circledConnector", className)}>
      {data.map((text, index) => (
        <div className="circledConnector_circledRow" key={text + index}>
          <span className="circledConnector_circled">{index + 1}</span>
          <div className="circledConnector_circledText">
            {text !== "renderCompFromProps" ? <Markdown source={text} />
              : comp}
          </div>
        </div>
      ))}
    </Container>
  )
}


CircledConnector.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  comp: PropTypes.node
}

CircledConnector.defaultProps = {
  className: null,
  comp: null
}

export default CircledConnector
